// extracted by mini-css-extract-plugin
export default {"root":"ChangeEmail_root__Z+EK+","container":"ChangeEmail_container__e4RBT","form":"ChangeEmail_form__+W2VQ"};